<div class="off" [class.off]="!isPlay" [class.play_yinfu]="isPlay" id="audio_btn" style="display: block;" (click)="togglePlay()">
    <div id="yinfu" [class.rotate]="isPlay"></div>
</div>
